import { ChevronLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from './Button'

interface BackButtonProps {
  /** Route of the previous step to return to. */
  to: string
}

/**
 * "← Back" — steps the user to the previous form step. Purely navigation: it
 * never clears anything (form state persists in the store), so returning to a
 * step shows everything already entered. Sits to the LEFT of the primary
 * Continue button on each step; pairs with the centered StartOverButton (reset)
 * below. Rendered as a quiet tertiary text button so it stays subordinate to
 * the primary Continue action.
 */
export function BackButton({ to }: BackButtonProps) {
  const navigate = useNavigate()
  return (
    <Button
      variant="tertiary"
      type="button"
      onClick={() => navigate(to)}
      style={{ gap: 'var(--spacing-1)', flexShrink: 0 }}
    >
      <ChevronLeft size={18} strokeWidth={2.2} />
      Back
    </Button>
  )
}
